import { motion } from "framer-motion";
import {
  Map,
  Fingerprint,
  FileText,
  Quote,
  Compass,
  Building2,
  MessageSquare,
  Mic,
  BarChart3,
  Route,
  LucideIcon,
} from "lucide-react";

interface Resultado {
  icon: LucideIcon;
  titulo: string;
  descripcion: string;
}

const resultados: Resultado[] = [
  {
    icon: Map,
    titulo: "Mapa de Situación e Informe de Brechas",
    descripcion: "Dónde estás y qué te separa de donde querés estar.",
  },
  {
    icon: Fingerprint,
    titulo: "Mapa de Identidad Profunda",
    descripcion: "Lo que solo vos podés decir sobre la pyme y la calle.",
  },
  {
    icon: FileText,
    titulo: "Plataforma de Marca Personal",
    descripcion:
      "El documento central: posicionamiento, propuesta de valor, esencia.",
  },
  {
    icon: Quote,
    titulo: "Declaración de Posicionamiento",
    descripcion:
      "Tu posición en una frase. El criterio que aprueba o descarta todo lo demás.",
  },
  {
    icon: Compass,
    titulo: "Mapa del Terreno Competitivo",
    descripcion: "Dónde está el espacio libre de la calle que podés ocupar.",
  },
  {
    icon: Building2,
    titulo: "Mapa de Arquitectura",
    descripcion:
      "Cómo se relacionan tu figura, Mercado Cheque y GWINN.",
  },
  {
    icon: MessageSquare,
    titulo: "Sistema de Mensajes por Audiencia",
    descripcion:
      "El juego directo a la pyme y el indirecto que leen los fondos.",
  },
  {
    icon: Mic,
    titulo: "Hoja de Ruta de Liderazgo Visible",
    descripcion:
      "Tu plan de presencia: charlas, cámaras, grupos empresarios.",
  },
  {
    icon: BarChart3,
    titulo: "Definición del Equipo 360 + OKRs y KPIs",
    descripcion:
      "Qué equipo se activa después, con qué objetivos y qué datos duros medimos.",
  },
  {
    icon: Route,
    titulo: "Hoja de Ruta de Fase 2",
    descripcion: "Qué se construye después, con qué prioridad y plazos.",
  },
];

const ChiappellaResultados = () => {
  return (
    <section
      id="resultados"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "#1d4a8c" }}
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at top, rgba(91,163,224,0.18), transparent 60%)",
        }}
        aria-hidden="true"
      />

      <div className="container px-4 max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block text-white/80">
            Lo que queda en tus manos
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1]">
            Diez entregables.
            <br />
            <span style={{ color: "#9CCBF0" }}>Un activo comercial.</span>
          </h2>
        </motion.div>

        {/* Cards grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {resultados.map((r, index) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.titulo}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
                className="rounded-2xl p-6 border border-white/15 backdrop-blur-sm"
                style={{ background: "rgba(10,22,42,0.55)" }}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{
                      background:
                        "linear-gradient(135deg, #3B8BD4, #1d4a8c)",
                    }}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <span
                    className="font-display text-2xl font-bold"
                    style={{ color: "rgba(255,255,255,0.25)" }}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-lg md:text-xl font-semibold text-white mb-2 leading-snug">
                  {r.titulo}
                </h3>
                <p className="text-sm md:text-base text-white/75 leading-relaxed">
                  {r.descripcion}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ChiappellaResultados;
